import goat1 from 'img/goat1.gif';
import fc1 from 'img/fc1.gif';
import alias1 from 'img/alias1.gif';
import goatgroup from 'img/goatgroup.gif';

export const GOAT_IMAGES = [goat1];
export const FC_IMAGES = [fc1];
export const ALIAS_IMAGES = [alias1];
export const GOATGROUP_IMAGES = [goatgroup];
